import { Library, Cpu, Settings2, Lock, Store, Palette } from 'lucide-react';
import { useBrand, BrandMark } from './BrandProvider';
import { InstallButton } from './InstallPrompt';

const NAV = [
  { id: 'vault', label: 'Vault', icon: Library },
  { id: 'studio', label: 'Studio', icon: Cpu },
  { id: 'admin', label: 'Admin', icon: Palette },
  { id: 'config', label: 'Config', icon: Settings2 },
];

export default function TopBar({ view, setView, active, onLock }) {
  const { brand, features } = useBrand();
  const nav = features.enableGameStudio ? NAV : NAV.filter((n) => n.id === 'admin' || n.id === 'config');
  return (
    <header data-testid="dev-topbar" className="dev-topbar relative z-20 pt-safe border-b border-violet-500/15 bg-titan-bg/80 backdrop-blur-xl">
      <div className="h-14 px-3 sm:px-5 flex items-center gap-3">
        <button data-testid="brand-home" onClick={() => setView('vault')} className="flex items-center gap-2 shrink-0">
          <BrandMark />
          <span className="hidden sm:block text-sm font-extrabold tracking-[.28em] neon-text">{brand.name.toUpperCase()}</span>
          <span className="hidden md:block t-label">// Area Sviluppatore</span>
        </button>
        <nav className="flex items-center gap-1 ml-1 sm:ml-4">
          {nav.map((n) => (
            <button key={n.id} data-testid={`nav-${n.id}`} onClick={() => setView(n.id)}
              className={`flex items-center gap-1.5 rounded-lg px-2.5 sm:px-3 py-1.5 text-xs font-semibold tracking-wider transition-colors ${view === n.id ? 'bg-violet-500/20 text-violet-200 shadow-[inset_0_0_0_1px_rgb(var(--violet-500)/.45)]' : 'text-slate-400 hover:text-slate-100 hover:bg-white/5'}`}>
              <n.icon className="h-4 w-4" /><span className="hidden sm:inline">{n.label.toUpperCase()}</span>
            </button>
          ))}
        </nav>
        {active && view === 'studio' && (
          <div data-testid="active-game-title" className="hidden md:flex items-center gap-2 ml-3 min-w-0 text-xs text-cyan-300">
            <span className="h-1.5 w-1.5 rounded-full bg-cyan-400 shadow-[0_0_8px_rgb(var(--cyan-500))]" />
            <span className="truncate max-w-[240px]">{active.title}</span>
          </div>
        )}
        <div className="ml-auto flex items-center gap-2">
          <a href="/" data-testid="nav-store" className="flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-semibold tracking-wider text-cyan-300 hover:bg-cyan-500/10 transition-colors"><Store className="h-4 w-4" /><span className="hidden sm:inline">STORE</span></a>
          <InstallButton />
          <button data-testid="lock-btn" onClick={onLock} title="Blocca" className="h-9 w-9 rounded-lg flex items-center justify-center text-slate-400 hover:text-cyan-300 hover:bg-white/5 transition-colors">
            <Lock className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
}
